import React from "react";
import { useAuth } from "../../hooks/useAuth";

const Login: React.FC = () => {
  const { login, loading } = useAuth();

  return (
    <div className="min-h-dvh flex flex-col items-center justify-center bg-base-200 p-4">
      <div className="card w-full max-w-md bg-base-100 shadow-xl">
        <div className="card-body items-center text-center">
          <div className="w-24 h-24 bg-primary text-primary-content rounded-full flex items-center justify-center mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
          </div>
          <h2 className="card-title text-2xl font-bold mb-2">Connexion</h2>
          <p className="text-base-content/70 mb-6">
            Connectez-vous avec votre compte Microsoft pour accéder à l'application de traçabilité.
          </p>
          <div className="card-actions w-full">
            <button 
              className={`btn btn-primary btn-block ${loading ? "loading" : ""}`}
              onClick={login}
              disabled={loading}
            >
              {!loading && (
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 23 23">
                  <path fill="#f3f3f3" d="M0 0h11v11H0zM12 0h11v11H12zM0 12h11v11H0zM12 12h11v11H12z"/>
                </svg>
              )}
              Se connecter avec Microsoft
            </button>
          </div>
        </div>
      </div>
      <div className="mt-8 text-xs text-base-content/50">
        &copy; {new Date().getFullYear()} TPP Traçabilité
      </div>
    </div>
  );
};

export default Login;
